import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-custom-menu',
    templateUrl: './custom-menu.component.html',
})
export class CustomMenuComponent {
    public readonly label = input.required<string>();
    public readonly menuOptions = input.required<string[]>();
}
